export const images = {
  playerAvatar: require("../../../assets/images/avatar-kick-dark.jpg"),
  assist: require("../../../assets/images/assist_image.png"),
};
